/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DriverObjectInstance} from "../models/driver-object-instance";
import {DriverObjectService} from "../services/driver-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class DriverObjectInstancesResolver implements Resolve<DriverObjectInstance[]> {

  constructor(
    private mDriverObjectService: DriverObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DriverObjectInstance[]> {
    try {
      return await this.mDriverObjectService.getAllDriverObjectInstances();
    } catch (error) {
      console.error("Problem resolving Driver Object Instances... Error: " + error, error);
    }
  }

}
